import { Component, EventEmitter, input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { OverlayComponent } from '@components/overlay/overlay.component';

@Component({
  selector: 'app-dialog',
  standalone: true,
  imports: [CommonModule, TranslateModule, OverlayComponent],
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss'],
})
export class DialogComponent {
  @Output() handleCloseDialog = new EventEmitter<void>();

  isShowDialog = input<boolean>(false);
  dialogTitle = input<string>();
  dialogDescription = input<string>();
  width = input<string>();
  imgSrc = input<string>();
  imgAlt = input<string>();
  textAlign = input<'right' | 'left' | 'center'>();
  closeIcon = input<boolean>(false);

  closeDialog() {
    this.handleCloseDialog.emit();
  }
}
